var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 41,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.5v40.1H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6797d6",
    d: "M-13.4 0h80.2v40.1h-80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.7 9.6-2.5 1.8 1-2.8-2.6-1.8h3.1l1-2.8 1 2.8h3.1l-2.5 1.8 1 2.8m-2.6 19.2-2.5-1.8 1 2.8-2.6 1.8h3.1l1 2.8 1-2.8h3.1l-2.5-1.8 1-2.8m-14.8-7.2-2 2.4.2-3-3-1 3-.8.2-3 1.7 2.4 3-1-2 2.5 1.8 2.4m21.5-1 2 2.5-.2-3 3-1-3-.8-.1-3-1.8 2.4-3-1 2 2.5-1.8 2.4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/fm.3203b35c6b5ce6d3812b65533585faf4.svg";
export { ForwardRef as ReactComponent };